      <ul class="services"{{{ root }}}>
{{#each items}}
        <li class="service reveal"{{{ edit }}}>
          <p class="service-no">{{ @pad }}</p>
          <h3 class="service-title"{{#if englishTitle}} data-tr-lang="en"{{/if}}{{{ title.attrs }}}>{{{ title.html }}}</h3>
          <p class="service-desc"{{{ desc.attrs }}}>{{{ desc.html }}}</p>
          <p class="service-meta"{{{ meta.attrs }}}>{{{ meta.html }}}</p>
        </li>
{{/each}}
      </ul>
